import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import bg4 from '../assets/bg4.jpg';
import expressWash from '../assets/bg3.jpg';
import interiorDetail from '../assets/bg1.jpg';
import exteriorDetail from '../assets/bg4.jpg';
import exclusivePackage from '../assets/bg2.jpg';
import additionalServices from '../assets/bg2.jpg';

const Services = () => {
  const [expanded, setExpanded] = useState(null);

  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const services = [
    {
      title: "Express Wash",
      details: (
        <>
          <p>Express Wash: $65-85 for Sedans, Small-medium SUVs, Large SUVs.</p>
          <ul className="list-disc list-inside">
            <li>Clean wheels, tires, and gas caps then apply tire dressing</li>
            <li>Thorough wash of vehicle using premium mitts and paint safe products</li>
            <li>Apply spray on P&S Beadmaker (Paint Protect)</li>
            <li>Dry vehicle with soft and safe microfiber towels</li>
            <li>Clean exterior windows</li>
            <li>Light interior vacuum and wipe down</li>
          </ul>
        </>
      ),
      image: expressWash,
    },
    {
      title: "Complete Interior Detail",
      details: (
        <>
          <p>Sedans: $120-$140, Small-medium SUVs: $140-160, Large SUVs: $160-180.</p>
          <ul className="list-disc list-inside">
            <li>Thorough vacuum (including crevices and trunk)</li>
            <li>Shampoo and extract seats and floor mats (takes care of most messes and spills)</li>
            <li>Clean and protect all interior panels (door panels, center console, dashboard, etc.)</li>
            <li>Clean all interior windows and mirrors</li>
            <li>Finish by cleaning doorjambs and doing any touchups</li>
          </ul>
        </>
      ),
      image: interiorDetail,
    },
    {
      title: "Complete Exterior Detail",
      details: (
        <>
          <p>Sedans: $60-70, Small-medium SUVs: $70-80, Large SUVs: $80-95.</p>
          <ul className="list-disc list-inside">
            <li>Clean wheels, tires, and fenders with safe products</li>
            <li>Thorough handwash of vehicle using premium mitts of entire exterior (including doorjambs), gas caps, and removal of bugs)</li>
            <li>Clay bar & iron remover to remove bonded decontaminants making paint smooth</li>
            <li>Apply a spray ceramic wax for layer of protection on paint good for 3-6 months</li>
            <li>Dress tires for layer of protection and shine</li>
            <li>Clean exterior windows</li>
          </ul>
        </>
      ),
      image: exteriorDetail,
    },
    {
      title: "Exclusive Package",
      details: (
        <>
          <p>Sedans: $160-175, Small-medium SUVs: $175-190, Large SUVs: $190-205.</p>
          <ul className="list-disc list-inside">
            <li>Includes everything in the Complete Interior Detail and Complete Exterior Detail</li>
          </ul>
        </>
      ),
      image: exclusivePackage,
    },
    {
      title: "Additional Services",
      details: (
        <>
          <ul className="list-disc list-inside">
            <li>Engine Bay Cleaning: +$25</li>
            <li>Headlight Restoration: +$20/ Headlight</li>
          </ul>
        </>
      ),
      image: additionalServices,
    },
  ];

  return (
    <div className="text-center">
      <motion.div
        className="relative h-96 bg-cover bg-center"
        style={{ backgroundImage: `url(${bg4})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center flex-col">
          <h1 className="text-[#EFF8E2] text-4xl font-bold mb-4">Our Services</h1>
          <motion.div
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
              transition: { duration: 0.2 },
            }}
            className="inline-block mb-4"
          >
            <a
              href="tel:+12067660409"
              className="bg-[#25292C] text-[#EFF8E2] px-4 py-2 rounded font-bold"
            >
              <span>📞</span>
              <span>Call us at (206) 766 0409 to Book</span>
            </a>
          </motion.div>
        </div>
      </motion.div>
      <div className="max-w-4xl mx-auto text-[#EFF8E2] px-4 pt-4 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4">
          {services.map((service, index) => (
            <ServiceOption
              key={index}
              index={index}
              title={service.title}
              details={service.details}
              image={service.image}
              expanded={expanded}
              handleToggle={handleToggle}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const ServiceOption = ({ index, title, details, image, expanded, handleToggle }) => {
  const { ref: inViewRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div ref={inViewRef} className="w-full">
      <motion.div
        className="bg-white bg-opacity-25 rounded-md p-4 flex flex-col items-center justify-center text-center hover:bg-opacity-50 transition duration-300 h-40 w-full cursor-pointer"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
        whileHover={{
          scale: 1.1,
          translateZ: 50,
          perspective: 1000,
          boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
          transition: { duration: 0.2 },
        }}
        onClick={() => handleToggle(index)}
      >
        <h2 className="text-3xl font-semibold mb-2">{title}</h2>
      </motion.div>
      {expanded === index && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="bg-[#EFF8E2] text-black p-4 mt-2 rounded-md"
        >
          {details}
        </motion.div>
      )}
    </div>
  );
};

export default Services;
